import { useState } from "react";
import { useNavigate } from "react-router-dom";
import GemapiRuDeGally from "./GemapiRuDeGally";
import GemapiRuDeMarivel from "./GemapiRuDeMarivel";
import GemapiPratique from "./PatrimoineSource";

const GemapiNavigationMenu = () => {
  const [activeSection, setActiveSection] = useState("ru-de-gally");
  const navigate = useNavigate();

  const handleSectionChange = (section: any) => {
    setActiveSection(section);
    navigate(`/gemapi?${section}`);
  };

  return (
    <>
      <div className="flex flex-col items-center mt-5 ">
        <div className="flex justify-center space-x-4">
          <div
            className={`cursor-pointer  text-xs md:text-base ${
              activeSection === "ru-de-gally"
                ? "text-black font-bold  text-xs md:text-base  "
                : ""
            }`}
            onClick={() => handleSectionChange("ru-de-gally")}
          >
            Ru de Gally
            <hr
              className={
                activeSection === "ru-de-gally"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer text-xs md:text-base  ${
              activeSection === "ru-de-marivel"
                ? "text-black font-bold  text-xs md:text-base  "
                : ""
            }`}
            onClick={() => handleSectionChange("ru-de-marivel")}
          >
            Ru de Marivel
            <hr
              className={
                activeSection === "ru-de-marivel"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer  text-xs md:text-base ${
              activeSection === "bonnes-pratiques"
                ? "text-black font-bold  text-xs md:text-base "
                : ""
            }`}
            onClick={() => handleSectionChange("bonnes-pratiques")}
          >
            Bonnes Pratiques
            <hr
              className={
                activeSection === "bonnes-pratiques"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
        </div>
        <div className="z-0 w-[420px] max-w-2xl border-t border-gray-200 dark:border-gray-800" />
      </div>

      {activeSection === "ru-de-gally" && <GemapiRuDeGally />}
      {activeSection === "ru-de-marivel" && <GemapiRuDeMarivel />}
      {activeSection === "bonnes-pratiques" && <GemapiPratique />}
    </>
  );
};

export default GemapiNavigationMenu;
